import {ICameraAngleWizardState} from "../../../types/ui/wizard/camera-angle";

export const initialCameraAngleState: ICameraAngleWizardState = {
  oldCameraAngle: 0
};
